import React from 'react';
import PropTypes from 'prop-types';
import { FilterSetController, Filter } from '@weezevent/nacre';
import { useSegment } from '../../../../components/tracking/trackingProvider';
import { Trans, useTranslation } from 'react-i18next';

const optionsStatus = [
    { key: 'active', text: <Trans i18nKey="ticket.common.active">active</Trans>, name: 'active' },
    { key: 'inactive', text: <Trans i18nKey="ticket.common.inactive">inactive</Trans>, name: 'inactive' },
    { key: 'unavailable', text: <Trans i18nKey="ticket.common.unavailable">unavailable</Trans>, name: 'unavailable' },
    { key: 'scheduled', text: <Trans i18nKey="ticket.common.scheduled">scheduled</Trans>, name: 'scheduled' },
    { key: 'expired', text: <Trans i18nKey="ticket.common.over">expired</Trans>, name: 'expired' },
    { key: 'deleted', text: <Trans i18nKey="ticket.common.deleted">deleted</Trans>, name: 'removed' }
];

const optionsDiscountType = [
    { key: 'amount', text: <Trans i18nKey="ticket.common.fixed_amount">fixed_amount</Trans>, name: 'amount' },
    { key: 'percent', text: <Trans i18nKey="ticket.common.percentage">percentage</Trans>, name: 'percentage' },
    { key: 'grid', text: <Trans i18nKey="ticket.common.pricing_table">pricing_table</Trans>, name: 'grid' }
];

const optionsUse = [
    { key: 'used', text: <Trans i18nKey="ticket.discounts.filter.used">used</Trans>, name: 'used' },
    { key: 'never', text: <Trans i18nKey="ticket.discounts.filter.never_used">never</Trans>, name: 'never' }
];

/**
 * Component for filtering and searching discount
 * @param {func}    setFilters: action to perform update state filters
 * @param {object}  search: params search of the nacre component
 * @param {number}  total: total of discounts
 * @param {Array}   filters: Array of filter params
 * @param {func}    onChange: action to check if filters is update
 */
export default function FilterComponent({ setFilters, search, loadingCount, total, filters, onChange, initialFilters }) {
    const { t } = useTranslation();
    const { track } = useSegment();
    return (
        <FilterSetController
            total={total}
            isLoadingTotal={loadingCount}
            labelTotal={t('ticket.common.discount', { count: total })}
            labelReset={t('ticket.discounts.filter.label_reset')}
            labelFilters={t('ticket.common.action.filter')}
            search={search}
            onChange={onChange}
            initialValues={Object.keys(filters).length > 0 ? filters : initialFilters}
            defaultValues={initialFilters}
            onOpen={() => track('ACTION > FILTER', { 'Page Title': 'DISCOUNTS', Application: 'WeezTicket nBO' })}
            onReset={() => setFilters(new Set(['active', 'inactive', 'unavailable', 'scheduled', 'expired']))}
        >
            <Filter
                onPostChange={() => track('ACTION > FILTER STATUS', { 'Page Title': 'DISCOUNTS', Application: 'WeezTicket nBO' })}
                name="status__in"
                multiple
                labelName={t('ticket.common.status')}
                options={optionsStatus}
                index="1"
            />
            <Filter
                onPostChange={() => track('ACTION > FILTER DISCOUNT TYPE', { 'Page Title': 'DISCOUNTS', Application: 'WeezTicket nBO' })}
                name="discount_type"
                labelName={t('ticket.common.discount_type')}
                options={optionsDiscountType}
                index="2"
            />
            <Filter
                onPostChange={() => track('ACTION > FILTER USAGE', { 'Page Title': 'DISCOUNTS', Application: 'WeezTicket nBO' })}
                name="usage"
                labelName={t('ticket.common.use')}
                options={optionsUse}
                index="3"
            />
        </FilterSetController>
    );
}

FilterComponent.propTypes = {
    setFilters: PropTypes.func.isRequired,
    search: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    initialFilters: PropTypes.object.isRequired,
    total: PropTypes.number.isRequired
};
